<script>
import { get_currency, get_decimal } from '../../../Helper/helper';
import { orderService, vendorService, } from '../../../services';
import ProductDetailShow from "./product-detail-show";
import config from "../../../config";
import { or } from 'vuelidate/lib/validators';
export default {
  components : {ProductDetailShow},
  props:['order','loading','orderStatus', 'order_id'],
  data(){
    return {
      config: config,
      items : [],
      currency: get_currency(),
      decimal: get_decimal(),
      count: 0,
      selected: [],
      cancel: [],
      isEnable: true,
      readyToCollect: 0,
      activeId: 0,
      showProductModal: false,
      productData: null,
      productLoading: false,
      reason:null,
      productId: null,
      modalShow: null,
      updatedPendingQuantities:null,
      penddingItmeId:null,
      updatedTotalQty:null,
      penddingItmeIds:[]
    }
  },
  watch:{
    order: function(){
      this.count = this.order.total_count;
    },
    
    // reason: function(){
    //   console.log('val',this.order.total_count);
    // }
  },
  methods: {
    totalPrice(item){
      return (parseInt(item.quantity) * parseFloat(item.item_price || 0)).toFixed(this.decimal) + ' ' +this.currency;
    },
    productQtyUpdate(item_data){
     
     // item_data = this.productData ?? item_data;
     // return (parseInt(item.quantity));
     if(this.penddingItmeId == item_data.id){

       // item_data.quantity = this.updatedPendingQuantities;
       return  parseInt(this.updatedPendingQuantities);
     }else{
       return parseInt(item_data.quantity);
     }
     
   },
    productPenddingQtyUpdate(item_data){
      // item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity
      if(this.penddingItmeId == item_data.id){
        item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity = this.updatedPendingQuantities;
        return  item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity;
      }else{
        return item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity;
      }
    },
    quantityUpdate(value){
      this.updatedPendingQuantities = (value.quantity);
      this.penddingItmeId = value.id;
      this.updatedTotalQty = value.total_qty;
      if (!this.penddingItmeIds.includes(value.id)) {
        this.penddingItmeIds.push(value.id);
      }
      this.$emit('quantityUpdate',{id:value.id,quantity:value.quantity});
    },
    defaultCalsss(item_data, order) {
      if(item_data.id == this.penddingItmeId && this.updatedPendingQuantities == item_data.total_qty){
        return (order.order_status == 10 && item_data.pending_order_products.length > 0 && item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity != 0 && item_data.pending_order_products[item_data.pending_order_products.length-1].total_quantity === item_data.quantity )

      }
    },
    newClass(item_data,order){
      if(item_data.id == this.penddingItmeId && this.updatedPendingQuantities == 0){
        return (item_data.pending_order_products.length > 0 && item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity == 0) || (order.order_status == '7' && item_data.delivered_quantity == 0);

      }else{
        return (item_data.pending_order_products.length > 0 && item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity == 0) || (order.order_status == '7' && item_data.delivered_quantity == 0);
      }
    },
    yellowClasses(item_data){
      
      if(item_data.id == this.penddingItmeId && this.updatedPendingQuantities != item_data.total_qty){
        return (this.updatedPendingQuantities == item_data.quantity && (item_data.quantity > 0))

      }else{

         return ((item_data.pending_order_products.length > 0 && (item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity != 0) && item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity !== item_data.pending_order_products[item_data.pending_order_products.length-1].total_quantity && (item_data.quantity > 0)))
      }
    },

    check: function(id) {
     
      var checkVal = this.selected.includes(id);

      if(checkVal)
      {
        this.activeId = 0;
        this.cancel.splice(this.cancel.indexOf(id), 1);
      }

      this.isEnable = this.isEnable;

      if(this.count === this.selected.length){
        this.activeId = 0;
        this.isEnable = !this.isEnable; 
      }
      else{
        this.isEnable = true; 
      }
    
      if(this.selected.length === 0){
        this.isEnable =  true;
      }

    },
    change(val){
      const data = {
         id : this.selected,
         status : val,
         data : this.order.order_item,
         order_id : this.order_id
      };
      orderService.orderReadyToCollect(data)
        .then(response => {
          if(response.data.code === 200){
            this.$toasted.success(response.data.message);
            this.readyToCollect = 1;
          }else{
            this.$toasted.error(response.data.message);
            this.readyToCollect = 1;
          }
          this.$emit("readyToCollect", this.readyToCollect);
          this.$emit("actionChanged");
      });
    },
    // cancelOrder: function(id) {
    //   this.activeId = id;
    //   var check = this.selected.includes(id);
      
    //   if(check)
    //   {
    //     this.activeId = 0;
    //     this.selected.splice(this.selected.indexOf(id), 1);
    //   }
    //   else{
    //     var checkId = this.cancel.includes(id);
    //     if(!checkId){
    //       this.cancel.push(id);
    //     }
    //   }
     
    //   if(this.selected !== [] && this.cancel !== []){
    //     this.isEnable = !this.isEnable; 
    //   }
    // },
    // cancelOrders(data)
    // {
    //   orderService.orderReadyToCollect(data)
    //       .then(response => {
    //         if(response.data.code === 200){
    //           this.readyToCollect = 1;
    //         }
    //         this.$emit("readyToCollect", this.readyToCollect);
    //   });
    // },
    onRowClickedDetail(item) {
      this.showProductModal = true;
      this.productLoading = true;
      if(item.pending_order_products.length != 0 && this.penddingItmeId == item.id){
        item.pending_order_products[item.pending_order_products.length-1].pending_quantity = this.updatedPendingQuantities;
      }else{
        item.pending_order_products.length != 0 ?? item.pending_order_products[item.pending_order_products.length-1].pending_quantity;
      }
      this.productData = item;
      this.productId = item.id;
     
    },
    modelShow(value){
      this.$emit("modalShow", value);
    },
    cancelReason(value){
     
      this.reason = value;
      this.productData.reason = this.reason;
     
      if(this.productData.quantity == 0){
        this.activeId = this.productId;
        var check = this.selected.includes(this.productId);
        if(check)
        {
          this.activeId = 0;
          this.selected.splice(this.selected.indexOf(this.productId), 1);
          
        }
        
        var checkId = this.cancel.includes(this.productId);

        if(!checkId){
          this.cancel.push(this.productId);
        }

        const index = this.order.order_item.findIndex(item => item.id === this.productId)
        
        if (index !== -1) {
          this.order.order_item.splice(index, 1);
        }
      }
     
      if(this.selected !== [] && this.cancel !== []){
        this.isEnable = !this.isEnable; 
      }
    }
    
  },
};

</script>

<template>

   <!-- View Detail Main Start -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="text-center text-danger my-2" v-if="loading">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{trans.get('__JSON__.Loading...')}}</strong>
      </div>
    </div>
    <div class="table-responsive item-order-main" v-if="!loading">
      <table class="table table-centered table-bordered item-table-main">
          <thead>
            <tr>
              <th style="text-align:center" scope="col" class="item-name-main">{{trans.get('__JSON__.Item Name')}}</th> 
              <th style="min-width: 80px;text-align:center" scope="col">{{trans.get('__JSON__.Qty.')}}</th>
              <th style="min-width: 80px;text-align:center" scope="col" v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'">{{trans.get('__JSON__.Ready')}}</th>
              <th style="min-width: 80px;text-align:center" scope="col" v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'">{{trans.get('__JSON__.Action')}}</th>
              <th style="min-width: 80px;text-align:center" scope="col">{{trans.get('__JSON__.Size')}}</th>
              <th style="min-width: 80px;text-align:center" scope="col">{{trans.get('__JSON__.Material')}}</th>
             </tr>
          </thead>
          <tbody v-for="(item, index) in order.items" :key="index">
            <tr v-for="(item_update, property) in item" :key="property">
              <td colspan="100%" style="padding-inline:0; border:0;">
                <table style="width:100%">
                  <colgroup>
                    <!-- Define column widths for inner table -->
                    <col>
                    <col style="width: 80px;">
                    <col style="width: 80px;">
                    <col style="width: 80px;">
                    <col style="width: 80px;" v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'">
                    <col style="width: 80px;" v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'">
                  </colgroup>
                  <tr 
                    v-for="(item_data, index1) in item_update.slice(0, item_update.length)" 
                    :key="index1" 
                    v-bind:class="{ 
                      defaultCalss :  defaultCalsss(item_data,order),
                      newClass: newClass(item_data,order),
                      greenClass: !((item_data.pending_order_products.length > 0 && item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity == 0) || (order.order_status == '7' && item_data.delivered_quantity == 0)) && order.order_status != 10 || selected.includes(item_data.id),
                      yellowClass: yellowClasses(item_data)
                    }"
                  >
                    <td style="border-left:0">
                      <div class="d-flex display-margin">
                        <div>
                          <img alt v-if="item_data.sub_products[0].product_image[0].image" title="image" class="vendor-img avatar-xs" :src="config.sub_product+item_data.sub_product_id+'/original/'+item_data.sub_products[0].product_image[0].image"/>   
                          <img  v-else class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt>
                        </div>
                        <div>
                          <span>{{ item_data.sub_products[0].product.item_name }}</span>
                          <span>{{ item_data.sub_products[0].selling_qty }} x {{ item_data.sub_products[0].size_attribute.size.att_name }} ({{item_data.sub_products[0].size_attribute.material.att_name}})
                          </span>
                          <div>
                            <span>ArtNr: {{ item_data.sub_products[0].product_number }}</span>
                            <span class="ml-5">EAN: {{ item_data.sub_products[0].barcode_number }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td align="center" v-if="order.order_status == '7'">
                      <p>{{item_data.delivered_quantity}}</p>
                    </td>
                    <td align="center" v-else>
                      <p v-if="item_data.pending_order_products.length > 0">
                        <span>{{ productPenddingQtyUpdate(item_data) }}</span>
                      </p>
                      <p v-else>{{ productQtyUpdate(item_data) }}</p>
                    </td>
                    
                    <td style="border-right:0" align="center" v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'">
                      <label class="form-checkbox">
                        <!-- :disabled="item_data.pending_order_products.length > 0 && item_data.pending_order_products[item_data.pending_order_products.length-1].pending_quantity == 0 ? true : false" -->
                        <input type="checkbox" @change="check(item_data.id)" :value="item_data.id" v-model="selected" >
                        <i class="form-icon"></i>
                      </label>
                    </td>
                    <td style="border-right:0" align="center" v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'">
                      <b-dropdown 
                        toggle-class="text-muted p-0"
                        variant="white"
                        v-model="cancel"
                        :value="item_data.id"
                        :disabled="item_data.pending_order_products.length > 0 && item_data.pending_order_products[0].pending_quantity == 0 ? true : false"
                      >
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-vertical font-size-18"></i>
                        </template>
              
                        <b-dropdown-item @click="onRowClickedDetail(item_data)" >
                          <span class="cancel-item">Cancel item from order</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>

                    <td align="center">
                      <!-- <p>{{ item_data.sub_products[0].size_attribute.size.att_name }}</p> -->
                       <p v-html="parseFloat(item_data.item_price || 0).toFixed(2) + ' ' + currency"></p>
                    </td>
                    <td align="center">
                      <!-- <p>{{ item_data.sub_products[0].size_attribute.material.att_name }}</p> -->
                       <p v-html="totalPrice(item_data)"></p>
                    </td>

                   
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <!-- View Detail Main End -->
    <!-- :disabled="isEnable" -->
    <div class="btn-style">
      <button v-if="orderStatus != 'Delivered' && orderStatus != 'Cancelled'" class="btn btn-outline--primary" @click="change(1)" :disabled="isEnable">Cancel Order</button>
      <button v-if="orderStatus=='Placed'" class="btn btn-outline--primary" @click="change(0)" :disabled="isEnable">Ready to collect</button>
    </div>
    <ProductDetailShow
      v-if="showProductModal"
      :productData="productData"
      :order="order"
      @hidden="showProductModal = false"
      @cancelReason="cancelReason"
      @modelShow="modelShow"
      @quantityUpdate="quantityUpdate"
      @actionChanged="$emit('refreshData')"
    />
    <!-- :loading="productLoading"  -->
  </div>
  
</template>
<style>
.dropdown-item{
  padding:0 10px;
}
.cancel-item{
  color: #e98c89 !important;
}
.dropdown-menu.show {
  top: auto !important;
  animation: none !important;
}
</style>